import onSound from "../assets/sounds/on.mp3";
import offSound from "../assets/sounds/off.mp3";
import { Settings } from "../storage/store";

// A short buzz, with Haptic Feedback on, on phones whose browser can vibrate
// (the app's Vibration.vibrate(70)).
export const hapticTap = () => {
  if (Settings.getHaptic()) navigator.vibrate?.(70);
};

// What the app does when a device is switched (app/hooks/useSwitchSound.js and
// app/components/SwitchComponent.js): the on or off sound with Switch Sound on,
// and the buzz with Haptic Feedback on.
export const switchFeedback = (on) => {
  if (Settings.getSound()) new Audio(on ? onSound : offSound).play().catch(() => {});
  hapticTap();
};
